"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const redirect_default_path_1 = __importDefault(require("components/atoms/redirect-default-path"));
const errors_1 = require("components/templates/errors");
const constants_1 = require("utils/constants");
const stockpile_1 = __importDefault(require("./stockpile"));
const store_1 = require("store");
const authorization_1 = require("utils/authorization");
const SiloConfig = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./silo'))));
const PitOperation = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./pit-operation'))));
const HaulerManager = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./hauler-manager'))));
const HopperControlLine = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./hopper-control-line'))));
const RfidTag = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./rfid-tag'))));
const Configuration = () => {
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const subModule = constants_1.pathList.configuration.subModule;
    const defaultRouteAuth = (0, authorization_1.defaultRoutePath)(userData.authorization, 'Configuration');
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(redirect_default_path_1.default, { from: constants_1.pathList.configuration.path, to: defaultRouteAuth }), (0, jsx_runtime_1.jsx)(react_1.Suspense, Object.assign({ fallback: (0, jsx_runtime_1.jsx)("div", { children: "loading..." }) }, { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: '*', element: (0, jsx_runtime_1.jsx)(errors_1.ErrorNotFound, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: subModule.siloConfig, element: (0, jsx_runtime_1.jsx)(SiloConfig, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: subModule.pitOperation, element: (0, jsx_runtime_1.jsx)(PitOperation, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: subModule.haulerManager, element: (0, jsx_runtime_1.jsx)(HaulerManager, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: subModule.hopperConfig, element: (0, jsx_runtime_1.jsx)(HopperControlLine, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: subModule.stockpile, element: (0, jsx_runtime_1.jsx)(stockpile_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: subModule.rfidTag, element: (0, jsx_runtime_1.jsx)(RfidTag, {}) })] }) }))] }));
};
exports.default = Configuration;
